import React, { useEffect, useState } from 'react';
import { dateNumberToString } from './helpers';
import { Wrapper } from './styled';

interface IProps {
  size: 'small' | 'medium' | 'large';
  boldPrefix?: boolean;
  endDate?: number;
  fontSize?: string;
  gap?: string;
  isDisabled?: boolean;
  showPrefix?: boolean;
  startDate: number;
  style?: React.CSSProperties;
  isOnly?: boolean;
  schedule?: [{ idDay: number; startTime: string; endTime: string }];
}

const ReusableDate = ({
  boldPrefix,
  endDate,
  fontSize,
  gap,
  isDisabled,
  showPrefix,
  startDate,
  style,
  isOnly,
  schedule,
  size
}: IProps) => {
  const [showEndDate, setShowEndDate] = useState<boolean>(false);
  useEffect(() => {
    if (startDate && endDate) {
      if (startDate === endDate) setShowEndDate(false);
      else setShowEndDate(true);
    }
  }, [startDate, endDate]);

  if (isOnly && schedule) {
    return (
      <Wrapper style={{ ...style }} gap={gap} isDisabled={isDisabled}>
        <span>
          {`${dateNumberToString(startDate, size)} de ${
            schedule?.length > 0 && schedule[0].startTime
          } a ${schedule[0].endTime}`}
        </span>
      </Wrapper>
    );
  }
  return (
    <Wrapper style={{ ...style }} gap={gap} isDisabled={isDisabled}>
      {/* {showIcon && <Icon name="calendar" size={sizeIcon} />} */}
      {!!startDate && (
        <p style={{ fontSize }}>
          {showPrefix && (
            <>{boldPrefix ? <b>Inicia: </b> : <span>Inicia: </span>}</>
          )}
          <span>{dateNumberToString(startDate, size)}</span>
        </p>
      )}
      {showEndDate && (
        <>
          {!!endDate && (
            <>
              <span>|</span>
              <p style={{ fontSize }}>
                {showPrefix && (
                  <>
                    {boldPrefix ? <b>Finaliza: </b> : <span>Finaliza: </span>}
                  </>
                )}
                <span>{dateNumberToString(endDate, size)}</span>
              </p>
            </>
          )}
        </>
      )}
    </Wrapper>
  );
};

export default ReusableDate;
